<section>

  <div class="instruction-text">
    Map External System Vendors to Onelynk Vendors
  </div>

  <div class="p-grid">
    <app-data-table [columns]="tableColumns" [value]="vendorMappings" sortField="quickBooksUser">
      <ng-template #vendorTemplate let-row="row" let-rowIndex="rowIndex" >
        <p-dropdown name="vendorId-{{rowIndex}}" [placeholder]="Validation.DropdownPlaceholder"
                    [options]="vendorDropDown"
                    [showClear]="true" [filter]="true"
                    [(ngModel)]="row.vendorId"></p-dropdown>
      </ng-template>
    </app-data-table>
  </div>

  <div class="p-grid">
    <div class="p-col-12 p-md-12 p-lg-12" style="text-align:right;margin-top:10px;">
      <button pButton class="button-inaction" icon="fa fa-refresh" type="button" label="Import Vendors" (click)="importVendorMappings()">
      </button>
      <button pButton type="button" class="button-action" icon="fa fa-check" label="Save"
              (click)="onClickSaveMappings()">
      </button>
    </div>
  </div>

</section>

